import { BookingStatusMap } from "utils/interfaces"
import { HelpTooltip, SupportDescription } from "components"
import { FormPage } from "modules/Payment/FormPage"
import { SuccessPage } from "modules/Payment/SuccessPage"
import { PaymentPage } from "modules/Payment/PaymentPage"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { CanceledPage } from "modules/Payment/CanceledPage"
import { ErrorPage } from "modules/Payment/ErrorPage"
import { Pages } from "modules/BookingCommon/common/constants"

export function Content() {
    const [{ currentPage, bookingStatus }] = usePaymentContext()

    if (bookingStatus === BookingStatusMap.PAY_ERROR) {
        return (
            <ErrorPage
                headline="Произошла ошибка"
                secondary={
                    <>
                        Попробуйте снова или обратитесь в&nbsp;службу поддержки
                        <span className="booking__error-support-tooltip-image">
                            <HelpTooltip
                                overlay={<SupportDescription lang="ru" className="is-dark" />}
                            />
                        </span>
                    </>
                }
            />
        )
    }

    if (
        bookingStatus === BookingStatusMap.CANCELLED ||
        bookingStatus === BookingStatusMap.CANCELLED_AFTER_PAYMENT ||
        bookingStatus === BookingStatusMap.PAID_AFTER_CANCELLATION ||
        bookingStatus === BookingStatusMap.CANCELLED_WITHOUT_REFUND
    ) {
        return <CanceledPage />
    }

    switch (currentPage) {
        case Pages.FORM:
            return <FormPage />
        case Pages.PAYMENT:
            return <PaymentPage />
        case Pages.SUCCESS:
            return <SuccessPage />
        default:
            return null
    }
}
